import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div data-testid="page-datenschutz" className="min-h-screen bg-[#FCEFE2] py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#A8482B] hover:text-[#8C3820] mb-10"
        >
          <ArrowLeft size={16} strokeWidth={1.5} />
          Zurück zur Startseite
        </Link>
        <div className="text-[11px] tracking-[0.3em] uppercase text-[#A8482B] mb-4">Rechtliches</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#2E1A10] tracking-tight">Datenschutz</h1>

        <div className="mt-12 space-y-8 text-[#6F4B34] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#2E1A10] mb-3">1. Verantwortlicher</h2>
            <p>
              Witali Albrecht — Psychologische Beratung, Im Berge,
              44536 Lünen, Deutschland. E-Mail: witalialbrecht21@web.de,
              Telefon: +49 177 1973430.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#2E1A10] mb-3">2. Vertraulichkeit</h2>
            <p>
              Der Schutz deiner persönlichen Daten ist mir besonders wichtig.
              Alle Inhalte unserer Gespräche unterliegen meiner Verschwiegenheit
              und werden streng vertraulich behandelt.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#2E1A10] mb-3">3. Kontaktaufnahme</h2>
            <p>
              Wenn du das Kontaktformular nutzt, werden deine Angaben (Name,
              E-Mail, optional Telefon, Anliegen und Nachricht) zur Bearbeitung
              deiner Anfrage gespeichert und mir per E-Mail übermittelt. Rechtsgrundlage
              ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen). Eine
              Weitergabe an Dritte erfolgt nicht.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#2E1A10] mb-3">4. Hosting</h2>
            <p>
              Diese Website wird bei einem Hosting-Dienstleister betrieben. Beim
              Aufruf der Website werden technisch bedingt Verbindungsdaten (z. B.
              IP-Adresse, Datum und Uhrzeit des Aufrufs) verarbeitet.
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse am sicheren Betrieb der Website).
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#2E1A10] mb-3">5. Speicherdauer</h2>
            <p>
              Anfragen werden nur so lange gespeichert, wie es zur Bearbeitung
              erforderlich ist. Du kannst jederzeit die Löschung deiner Daten
              verlangen.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#2E1A10] mb-3">6. Deine Rechte</h2>
            <p>
              Du hast das Recht auf Auskunft, Berichtigung, Löschung,
              Einschränkung der Verarbeitung, Datenübertragbarkeit sowie auf
              Widerspruch gegen die Verarbeitung deiner personenbezogenen Daten.
              Außerdem hast du das Recht, dich bei einer
              Datenschutz-Aufsichtsbehörde zu beschweren.
            </p>
          </section>

          <p className="text-sm text-[#A08064]">
            Hinweis: Diese Datenschutzerklärung ist eine vereinfachte Vorlage mit
            Platzhaltern und sollte vor dem Live-Betrieb von einer fachkundigen
            Stelle geprüft werden.
          </p>
        </div>
      </div>
    </div>
  );
}
